import {AlertDialogRuleListComponentController} from "../rule-list/AlertDialogRuleListComponent";
import {IOnDestroy, IOnInit} from "angular";

export abstract class RuleComponent implements IOnInit, IOnDestroy {
    private readonly ruleList: AlertDialogRuleListComponentController;

    public $onInit(): void {
        this.ruleList.addChildRuleComponent(this);
    }

    public $onDestroy(): void {
        this.ruleList.removeChildRuleComponent(this);
    }

    public abstract get wouldTriggerImmediately(): boolean;
}
